module.exports = {
  objectives: {
    APP_INSTALLS: 'APP_INSTALLS',
    BRAND_AWARENESS: 'BRAND_AWARENESS',
    CONVERSIONS: 'CONVERSIONS',
    EVENT_RESPONSES: 'EVENT_RESPONSES',
    LEAD_GENERATION: 'LEAD_GENERATION',
    LINK_CLICKS: 'LINK_CLICKS',
    LOCAL_AWARENESS: 'LOCAL_AWARENESS',
    MESSAGES: 'MESSAGES',
    OFFER_CLAIMS: 'OFFER_CLAIMS',
    PAGE_LIKES: 'PAGE_LIKES',
    POST_ENGAGEMENT: 'POST_ENGAGEMENT',
    PRODUCT_CATALOG_SALES: 'PRODUCT_CATALOG_SALES',
    REACH: 'REACH',
    VIDEO_VIEWS: 'VIDEO_VIEWS',
  },
  CHANNEL_MIN_BUDGET_PER_CURRENCY: {
    USD: {
      facebook: 5,
      instagram: 5,
      google_search: 5,
      google_display: 2,
      google_universal_playstore: 5,
      google_universal_appstore: 5,
      apple: 5,
      youtube: 10,
      microsoft: 5,
      kakao: 10,
      default: 1,
    },
    GBP: {
      facebook: 5,
      instagram: 5,
      google_search: 5,
      google_display: 2,
      google_universal_playstore: 5,
      google_universal_appstore: 5,
      apple: 5,
      youtube: 10,
      microsoft: 5,
      kakao: 10,
      default: 1,
    },
    KRW: {
      facebook: 5000,
      instagram: 5000,
      google_search: 5000,
      google_display: 2000,
      google_universal_playstore: 5000,
      google_universal_appstore: 5000,
      apple: 5000,
      youtube: 10000,
      microsoft: 5000,
      kakao: 10000,
      default: 1000,
    },
  },
  SCHEDULER_INTERVAL: {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
  },
};
